import { verifyMessage } from 'ethers/lib/utils';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useAccount,
  useDisconnect,
  useSignMessage,
  useSwitchNetwork,
} from 'wagmi';
import {
  authError,
  handleActive,
  handleVerificationToken,
  logout,
  selectCurrentNonce,
  selectCurrentToken,
  selectCurrentVerifyToken,
  selectGetUsersError,
  selectNotifications,
  setClientAddress,
} from '../../redux/slices/authSlice';
import {
  authThunk,
  getUsersThunk,
  notificationThunk,
  verifyAuthThunk,
} from '../../redux/thunks/auth-thunk';
import { parsedCookies } from '../../utils/cookies';
import SnackbarAction from '../customs/SnackbarAction';
import NotificationsDialog from '../games/modals/notifications/NotificationsDialog';

const AuthProvider = ({ children }) => {
  const [isNotiDialogOpen, setisNotiDialogOpen] = useState(false);
  const notifications = useSelector(selectNotifications);
  const getUsersError = useSelector(selectGetUsersError);
  const recoveredAddress = React.useRef();
  const authErrorMsg = useSelector(authError);
  const token = useSelector(selectCurrentToken);
  const verifyToken = useSelector(selectCurrentVerifyToken);
  const nons = useSelector(selectCurrentNonce);
  const { disconnect } = useDisconnect();
  const { address, isConnected } = useAccount();
  const dispatch = useDispatch();
  const { switchNetwork } = useSwitchNetwork();
  const { signMessage } = useSignMessage({
    onSuccess: async (data, variables) => {
      // Verify signature when sign message succeeds
      const signerAddress = verifyMessage(variables.message, data);
      recoveredAddress.current = signerAddress;
      dispatch(verifyAuthThunk({ wallet: signerAddress, signature: data }));
    },
    onError() {
      disconnect?.();
    },
  });
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = (snackbarId) => (
    <SnackbarAction closeSnackbarHandler={() => closeSnackbar(snackbarId)} />
  );

  useEffect(() => {
    if (isConnected) {
      dispatch(notificationThunk());
    }
  }, [isConnected]);

  useEffect(() => {
    const notifTitleStorage = window.localStorage.getItem('notification-title');
    const disabledNotifStorage = window.localStorage.getItem(
      'disable-notifications'
    );

    if (notifications && notifications[0]?.title) {
      console.log(window.localStorage.getItem('notification-title'));
      console.log(window.localStorage.getItem('disable-notifications'));
      if (!JSON.parse(notifTitleStorage) || !JSON.parse(disabledNotifStorage)) {
        setisNotiDialogOpen(true);
      } else if (
        (notifTitleStorage === notifications[0]?.title &&
          !JSON.parse(disabledNotifStorage)) ||
        JSON.parse(notifTitleStorage) !== notifications[0]?.title
      ) {
        setisNotiDialogOpen(true);
      }
    } else {
      setisNotiDialogOpen(false);
    }
  }, [notifications, notifications.title]);

  useEffect(() => {
    if (isConnected && address) {
      // removeCookie('verification')
      dispatch(setClientAddress(address));
      if (parsedCookies && parsedCookies?.address === address) {
        dispatch(handleVerificationToken(parsedCookies?.token));
        if (parsedCookies?.active) {
          dispatch(handleActive());
        }
      }
    }
  }, [isConnected, address]);

  useEffect(() => {
    if (isConnected && token && nons && !verifyToken) {
      signMessage({ message: nons });
    }
  }, [isConnected, token, verifyToken]);

  useEffect(() => {
    if (isConnected && address && !verifyToken) {
      dispatch(authThunk(address));
    }
    if (isConnected && verifyToken) {
      dispatch(getUsersThunk());
    }
    if (!isConnected) {
      dispatch(logout());
    }
  }, [isConnected, address, verifyToken]);

  useEffect(() => {
    if (authErrorMsg) {
      enqueueSnackbar('An error occured while authenticating', {
        variant: 'error',
        action,
      });
    }
    if (getUsersError) {
      enqueueSnackbar('An error occured while receving your data', {
        variant: 'error',
        action,
      });
    }
  }, [authErrorMsg, getUsersError]);

  return (
    <>
      {children}
      <NotificationsDialog
        open={isNotiDialogOpen}
        handleClose={() => setisNotiDialogOpen(false)}
        notifications={notifications?.[0]}
      />
    </>
  );
};

export default AuthProvider;
